import { SEARCH_FIBER_SITES } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const searchFiberSites = async (siteCode) => {
  try {
    const response = await apiClient.get(SEARCH_FIBER_SITES(siteCode), {});

    // Filter the response to only include the 30 specific fields for FTTS Site List
    const allowedFields = [
      'site_code',
      'project_name',
      'status',
      'onfp_planning_remarks',
      'bp_remarks',
      'comments',
      'phase_name',
      'bp',
      'fiber_site_name',
      'lat',
      'long',
      'technical_city',
      'region',
      'fiber_pop_id',
      'ring_name',
      'ring_unique_name',
      'ring_name_nms',
      'cutover_date',
      'total_length',
      'on_net',
      'off_net',
      'prefix',
      'old_site_code',
      'replacement_site_code',
      'replacement_site_name',
      'replacement_site_lat',
      'replacement_site_long',
      'replacement_site_proposed_ring',
      'addendum_status',
      'vendor',
      'descope_status',
      'is_ftts',
      'uploaded_at',
      'id',
    ];

    // Filter the data to only include allowed fields
    if (response?.data?.response && Array.isArray(response.data.response)) {
      const filteredData = response.data.response.map((item) => {
        const filteredItem = {};
        allowedFields.forEach((field) => {
          if (item.hasOwnProperty(field)) {
            filteredItem[field] = item[field];
          }
        });
        return filteredItem;
      });

      return {
        data: filteredData,
      };
    }

    return response?.data?.response || response?.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
